<template>
  <!-- 根容器 -->
  <div id="app" class="df fdc gundongtiaox">


    <!-- 顶部导航栏 -->
    <nav v-show="isDetail" class="navWhiteBg df jcc" ref="navContainer" @mouseenter="hoverNav(true)"
      @mouseleave="hoverNav(false)">
      <div class="main_nav df alic jcsb">


        <!-- logo 点击回首页 -->
        <div @click="handleLogo">
          <img src="@/assets/imgs/common/logoBig2.png" alt="" class="navLogo" ref="navLogo" />
        </div>
        <!-- 路由导航 -->
        <div class="routerInfo">
          <div class="info">
            <img src="@/assets/imgs/common/phoneYellow.png" alt="">
            <p class="phoneNum">(028) 6207 3080 / 180 1141 3583</p>
            <p class="qwImg" @mouseenter="showQR2 = true" @mouseleave="showQR2 = false">公众号</p>
            <img v-show="showQR2" class="qwImgT" src="@/assets/imgs/common/ereal_QR.png" alt="">
          </div>
          <div class="router_nav">
            <router-link to="/">首页</router-link>
            <router-link to="/about" active-class="router-link-exact-active">关于一真</router-link>
            <router-link to="/product" active-class="router-link-exact-active">咨询产品</router-link>
            <router-link to="/case" active-class="router-link-exact-active">专业案例</router-link>
            <router-link to="/info" active-class="router-link-exact-active">一真资讯</router-link>
          </div>
        </div>
      </div>


    </nav>


    <!-- 路由视图显示区域 -->
    <div class="routerView">
      <router-view />
    </div>


    <!-- 页脚 -->
    <footer class="footerName">
      <div class="footer-container">
        <div style="margin: 0 auto; width: 1384px; padding-top: 50px;height:100%;position: relative">
          <!-- 页脚 logo -->
          <div class="logo">
            <img style="width:110px" src="@/assets/imgs/common/logo.png" alt="">
          </div>


          <!-- 联系信息区域 -->
          <div class="contact_information df jcsb alic">
            <div>
              <!-- 电话 -->
              <div class="phone_num df alic">
                <img src="@/assets/imgs/common/phone_icon.png" alt="" class="contact_icon">
                <span class="phone_num1">联系电话 : (028)-6207-3080 / 180-1141-3583</span>
              </div>


              <!-- 邮箱 -->
              <div class="phone_num df alic">
                <img src="@/assets/imgs/common/email_icon.png" alt="" class="contact_icon">
                <span>求职简历可投至 : erealhr@163.com</span>
              </div>
              <!-- 微信公众号 -->
              <!-- <div class="phone_num df alic" style="cursor: pointer; width: 120px;" @mouseenter="showQR = true"
                @mouseleave="showQR = false">
                <img src="@/assets/imgs/common/wx_icon.png" alt="" class="contact_icon">
                <span>关注公众号</span>
              </div> -->
            </div>


            <!-- 二维码 -->
            <div class="QrBtn">
              <img src="@/assets/imgs/common/ereal_QR.png" alt="">
            </div>
          </div>


          <!-- 页脚标语 -->
          <div class="slogan df fdc alic">
            <p>让更多的组织优秀起来 <span></span>让更多的人高贵起来</p>
            <p>Make More Organizations Outstanding Make More People Noble</p>
          </div>


          <!-- 底部导航栏部分 - 放在这里 -->
          <div class="footerBtns">
            <!-- 关于一真 -->
            <div class="nav-column nav-column2">
              <h4 class="nav-title">关于一真</h4>
              <ul class="nav-list double-col">
                <li v-for="item in aboutList" :key="item.name" @click="handleNavClick(item)">
                  {{ item.name }}
                </li>
              </ul>
            </div>


            <!-- 管理咨询 -->
            <div class="nav-column">
              <h4 class="nav-title">管理咨询</h4>
              <ul class="nav-list double-col">
                <li v-for="item in consultList" :key="item.name" @click="handleNavClick(item)">
                  {{ item.name }}
                </li>
              </ul>
            </div>


            <!-- 数智科技 -->
            <div class="nav-column">
              <h4 class="nav-title">数智科技</h4>
              <ul class="nav-list">
                <li v-for="item in techList" :key="item.name" @click="handleNavClick(item)">
                  {{ item.name }}
                </li>
              </ul>
            </div>


            <!-- 专业案例 -->
            <div class="nav-column nav-column3">
              <h4 class="nav-title">专业案例</h4>
              <ul class="nav-list double-col">
                <li v-for="item in caseList" :key="item.name" @click="handleNavClick(item)">
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>


        <!-- 页脚文字 版权声明&备案号 -->
        <div class="copyright">
          <div class="df jcsb" style="width: 1384px; margin: 0 auto;">
            <p>法律声明 COPYRIGHT@2001-2026 ALL RIGHTS RESERVED</p>
            <p>版权所有: 四川一真管理咨询有限公司</p>
            <p>蜀ICP备2023018241号-2 全程策划: 一真IT部</p>
          </div>
        </div>
      </div>
    </footer>


    <!-- 回到顶部的功能 -->
    <div class="BackTop" v-show="showBackTop" @click="backToTop">
      <img src="./assets/imgs/home/backTop.png" alt="">
    </div>


    <!-- 公示功能 -->
    <div class="publicNotice">
      <p><img src="./assets/imgs/common/publicNotice2.png" alt=""></p>
      <div class="publicNoticePop">
        <!-- 第一级：一真公司 -->
        <div class="companyItem">
          <p class="companyName">四川一真管理咨询有限公司</p>
          <div class="reportList">
            <p class="lookFile" @click="gOlookFile('ESG（环境、社会和公司治理）报告', 'yz')">ESG（环境、社会和公司治理）报告</p>
            <p class="lookFile" @click="gOlookFile('绿色发展规划报告', 'yz')">绿色发展规划报告</p>
            <p class="lookFile" @click="gOlookFile('废气废水废固报告', 'yz')">废气废水废固报告</p>
            <p class="lookFile" @click="gOlookFile('能评报告', 'yz')">能评报告</p>
            <p class="lookFile" @click="gOlookFile('企业创新成果报告', 'yz')">企业创新成果报告</p>
            <p class="lookFile" @click="gOlookFile('创新激励机制报告', 'yz')">创新激励机制报告</p>
            <p class="lookFile" @click="gOlookFile('绿电使用评价报告', 'yz')">绿电使用评价报告</p>
            <p class="lookFile" @click="gOlookFile('研发团队规模报告', 'yz')">研发团队规模报告</p>

          </div>
        </div>
        <!-- 成都柏瑞恩公司 -->
        <div class="companyItem">
          <p class="companyName">成都柏瑞恩数据服务有限公司</p>
          <div class="reportList">
            <p class="lookFile" @click="gOlookFile('环境、社会、公司治理（ESG）报告', 'bre')">环境、社会、公司治理（ESG）报告</p>
            <p class="lookFile" @click="gOlookFile('绿色发展顶层规划报告', 'bre')">绿色发展顶层规划报告</p>
            <p class="lookFile" @click="gOlookFile('能评报告', 'bre')">能评报告</p>
            <p class="lookFile" @click="gOlookFile('企业科技创新报告', 'bre')">企业科技创新报告</p>
            <p class="lookFile" @click="gOlookFile('创新激励机制报告', 'bre')">创新激励机制报告</p>
            <p class="lookFile" @click="gOlookFile('绿色电力评价报告', 'bre')">绿色电力评价报告</p>
            <p class="lookFile" @click="gOlookFile('研发团队规模报告', 'bre')">研发团队规模报告</p>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>


<script>
// 新增：引入nprogress核心和样式
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'


export default {
  data() {
    return {
      // 导航背景是否为白色
      isBackgroundWhite: false,
      // 导航 logo 图片路径
      navLogoSrc: require("@/assets/imgs/common/logo.png"),
      // 鼠标 hover 状态
      hoverState: false,
      // 回到顶部的显示和隐藏
      showBackTop: false,
      isDetail: true,
      showQR: false,  // 控制二维码显示/隐藏
      showQR2: false,  // 控制二维码显示/隐藏
      // 关于一真
      aboutList: [
        { name: '我们', path: '/about/us', category: 1, subcategory: 1 },
        { name: '客户', path: '/about/clients', category: 1, subcategory: 2 },
        { name: '文化', path: '/about/culture', category: 1, subcategory: 3 },
        { name: '业务', path: '/about/business', category: 1, subcategory: 4 },
        { name: '服务', path: '/about/service', category: 1, subcategory: 5 },
        { name: '肯定', path: '/about/recognition', category: 1, subcategory: 6 }
      ],
      // 管理咨询（双列）
      consultList: [
        { name: '战略管理', path: '/consult/strategy', category: 2, subcategory: 1 },
        { name: '卓越绩效', path: '/consult/performance', category: 2, subcategory: 2 },
        { name: '政策研究', path: '/consult/policy', category: 2, subcategory: 3 },
        { name: '企业文化', path: '/consult/culture', category: 2, subcategory: 4 },
        { name: '社会责任', path: '/consult/social', category: 2, subcategory: 5 },
        { name: '管理创新', path: '/consult/innovation', category: 2, subcategory: 6 },
        { name: '精益管理', path: '/consult/lean', category: 2, subcategory: 7 },
        { name: '组织绩效', path: '/consult/org-performance', category: 2, subcategory: 8 },
        { name: '国企改革', path: '/consult/reform', category: 2, subcategory: 9 },
        { name: '赛事包装', path: '/consult/events', category: 2, subcategory: 10 }
      ],
      // 数智科技
      techList: [
        { name: '数据分析应用', path: '/tech/data-analysis', category: 3, subcategory: 1 },
        { name: '专题监测分析', path: '/tech/monitoring', category: 3, subcategory: 2 },
        { name: '数据运维服务', path: '/tech/operations', category: 3, subcategory: 3 },
        { name: 'RPA机器人研发', path: '/tech/rpa', category: 3, subcategory: 4 },
        { name: 'IT系统开发/数据驾驶舱', path: '/tech/it-system', category: 3, subcategory: 5 }
      ],
      // 专业案例（双列）
      caseList: [
        { name: '互联网事业部', path: '/cases/internet', category: 4, subcategory: 1 },
        { name: '营销管理', path: '/cases/marketing', category: 4, subcategory: 2 },
        { name: '财务管理', path: '/cases/finance', category: 4, subcategory: 3 },
        { name: '人力资源管理', path: '/cases/hr', category: 4, subcategory: 4 },
        { name: '建设管理', path: '/cases/construction', category: 4, subcategory: 5 },
        { name: '党建团青管理', path: '/cases/party', category: 4, subcategory: 6 },
        { name: '审计监察管理', path: '/cases/audit', category: 4, subcategory: 7 },
        { name: '生产管理', path: '/cases/production', category: 4, subcategory: 8 },
        { name: '发展管理', path: '/cases/development', category: 4, subcategory: 9 },
        { name: '安全管理', path: '/cases/safety', category: 4, subcategory: 10 },
        { name: '物资管理', path: '/cases/materials', category: 4, subcategory: 11 },
        { name: '办公室管理', path: '/cases/office', category: 4, subcategory: 12 },
        { name: '企业综合管理', path: '/cases/enterprise', category: 4, subcategory: 13 }
      ]
    };
  },
  methods: {
    gOlookFile(index, type) {
      console.log(index)
      const pdfUrl = `/docks/lookFile/${type}/${index}.pdf`
      window.open(pdfUrl, '_blank')
    },

    // 鼠标进入或离开导航栏
    hoverNav(flag) {
      this.hoverState = flag;
      this.updateNavStyle();
    },


    // 点击 logo，回到首页或回到顶部
    handleLogo() {
      if (this.$router.currentRoute.path !== "/") {
        this.$router.push("/");
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },


    // 更新导航栏样式
    updateNavStyle() {
      const scrollDistance = window.pageYOffset;


      // hover 时导航栏背景为白色，logo 黑色
      if (this.hoverState) {
        this.isBackgroundWhite = true;
        this.navLogoSrc = require("@/assets/imgs/common/logo_black.png");
        return;
      }


      // 滚动时，导航背景为白色，logo 黑色
      if (scrollDistance > 100) {
        this.isBackgroundWhite = true;
        this.navLogoSrc = require("@/assets/imgs/common/logo_black.png");
      } else {
        // 默认导航栏样式
        this.isBackgroundWhite = false;
        this.navLogoSrc = require("@/assets/imgs/common/logo.png");
      }
    },
    // 滚动监听
    navScroll() {
      const scrollDistance = window.pageYOffset;
      console.log(scrollDistance, "多少")
      // 导航阴影
      if (scrollDistance < 817) {
        this.$refs.navContainer.classList.remove("navBoxShadow");
      } else {
        this.$refs.navContainer.classList.add("navBoxShadow");
      }


      // 回到顶部按钮显隐
      this.showBackTop = scrollDistance >= 100;


      this.updateNavStyle();
    },
    // 回到顶部
    backToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleNavClick(item) {
      // 路由跳转
      this.$router.replace(item.path)
      if (item.category == 1) {
        this.$router.push("/about")
        sessionStorage.setItem('subcategory', item.subcategory)
      } else if (item.category == 2) {
        this.$router.push({
          name: 'product', params: {
            category: item.category,
            subcategory: item.subcategory
          }
        })
      } else if (item.category == 3) {
        this.$router.push({
          name: 'product', params: {
            category: item.category,
            subcategory: item.subcategory
          }
        })
      } else if (item.category == 4) {
        this.$router.push("/case")
        sessionStorage.setItem('subcategoryCase', item.subcategory)
      }
    }
  },
  mounted() {
    sessionStorage.setItem('subcategory', '')
    // 初始化导航样式
    this.$nextTick(() => {
      this.updateNavStyle();
    });
    // 添加滚动事件监听
    window.addEventListener("scroll", this.navScroll);


    // 新增：配置nprogress（白色细条样式）
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false, // 隐藏转圈图标，只保留顶部细条
      trickleSpeed: 100,
      minimum: 0.08
    });


    // 新增：监听页面资源加载
    window.addEventListener('loadstart', () => {
      NProgress.start()
    })
    window.addEventListener('load', () => {
      NProgress.done()
    })
    window.addEventListener('error', () => {
      NProgress.done()
    })


    // 新增：监听路由切换
    this.$router.beforeEach((to, from, next) => {
      NProgress.start()
      next()
    })
    this.$router.afterEach(() => {
      NProgress.done()
    })
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.navScroll);


    // 新增：移除nprogress相关监听，防止内存泄漏
    window.removeEventListener('loadstart', () => NProgress.start())
    window.removeEventListener('load', () => NProgress.done())
    window.removeEventListener('error', () => NProgress.done())
  },
  watch: {
    // 路由切换时更新导航样式
    $route(to, from) {
      // 精确匹配 /detail
      if (to.path == '/detail') {
        this.isDetail = false
      } else {
        this.isDetail = true
      }
      this.$nextTick(() => {
        this.updateNavStyle();
      });
    },
  },
};
</script>


<style lang="less">
/* 根容器样式 */
.gundongtiaox {
  box-sizing: border-box;
  user-select: none;
}


/* 自定义滚动条样式 */
.gundongtiaox::-webkit-scrollbar {
  // 如果到时候需要滚动条 再把这个加载出来就可以了
  width: 0px;
}


.gundongtiaox::-webkit-scrollbar-thumb {
  background: rgba(110, 110, 110, 0.5);
  border-radius: 10px;
  cursor: pointer;
}


.gundongtiaox::-webkit-scrollbar-thumb:hover {
  background: rgba(53, 53, 53, 0.7);
}


.gundongtiaox::-webkit-scrollbar-track {}


/* 新增：nprogress进度条样式（白色细条） */
#nprogress {
  pointer-events: none;
}


#nprogress .bar {
  background: #5c8fd3; // 白色细条
  position: fixed;
  z-index: 999999; // 确保在导航栏上方
  top: 0;
  left: 0;
  width: 100%;
  height: 2px; // 细条高度，可根据需要调整
}


#nprogress .peg {
  display: none; // 隐藏默认阴影，仅保留纯细条
}


/* 响应式设计 */
@media (max-width: 1920px) {
  body {
    min-width: 1256px;
  }


  nav {
    min-width: 800px;
  }
}


/* 根容器字体及布局 */
#app {
  font-family: PingFang;
  position: relative;
  box-sizing: border-box;
}


/* 导航栏基础样式 */
nav {
  width: 100%;
  height: 80px;
  box-sizing: border-box;
  position: fixed;
  z-index: 999;
}


/* 导航 logo 样式 */
.navLogo {
  width: 100px;
  cursor: pointer;
}


/* 导航阴影效果 */
.navBoxShadow {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}


/* 主导航容器 */
.main_nav {
  height: 100%;
  // width: 1256px;
  width: 1920px;
  box-sizing: border-box;
  padding: 0px 80px;
  position: relative;
}



.routerInfo {
  height: 100%;
  box-sizing: border-box;
  padding: 18px 0px 1px;
  display: flex;
  flex-direction: column;
  margin-top: 1px;
  justify-content: space-between;


  .info {
    display: flex;
    align-items: center;
    justify-content: end;
    position: relative;


    .qwImgT {
      position: absolute;
      top: 30px;
      right: -40px;
      // width: 80px;
    }


    img {
      margin-right: 5px;
    }


    .phoneNum {
      font-size: 24px;
      // color: #154899;
      color: #ffae00;
      font-weight: bold;
      margin-right: 30px;
    }


    .qwImg {
      font-size: 15px;
      font-weight: bold;
      color: #000;
      border-left: 1px solid #ccc;
      line-height: 12px;
      padding: 0px 0px 0px 10px;
      cursor: pointer;
      font-family: "Microsoft Yahei", "Helvetica Neue", Helvetica, Arial, sans-serif;
    }
  }
}


/* 路由导航样式 */
.router_nav {
  // width: 1920px;
  // background: red;
  // left: 0px;
  // top: 60px;
  // position: absolute;



  box-sizing: border-box;
  font-size: 17px;
  height: 40px;
  // margin-bottom: 10px;
  // line-height: 80px;


  a {
    color: #fff;
    display: inline-block;
    margin-left: 70px;
    height: 100%;
    box-sizing: border-box;


    &:nth-of-type(1) {
      margin-left: 0;
    }


    &:hover {
      // color: #0080ff;
      color: #084499;
      border-bottom: 4px solid #084499;
    }
  }


  /* 当前激活路由样式 */
  .router-link-exact-active {
    // color: #0080ff;
    color: #084499;
    border-bottom: 4px solid #084499;
  }
}


/* 白色背景导航栏样式 */
.navWhiteBg {
  background-color: #fff;
  height: 100px;
  transition: background-color 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);


  .router_nav {
    a {
      // color: #000;
      color: rgba(0, 0, 0, 0.8);


      &:hover {
        color: #084499;
        transition: color 0.2s ease;
      }
    }


    .router-link-exact-active {
      color: #084499;
    }
  }
}


/* 页脚样式 */
.footerName {
  border-top: 12px solid #154899;
  background: url("@/assets/imgs/common/footer_bg.png") no-repeat center/cover;
  width: 100%;
  height: 500px; // 新增：固定高度
  min-height: 500px; // 新增：防止被压缩
  max-height: 500px; // 新增：防止被撑开
  box-sizing: border-box;
  color: #fff;
  position: relative;
  overflow: hidden; // 新增：防止内容溢出
  display: flex;
  flex-direction: column;


  // 新增：容器撑满高度，flex 布局分配空间
  .footer-container {
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
  }


  .logo {
    // margin-bottom: 40px;
  }


  .contact_information {
    font-size: 14px;
    text-align: center;
    margin-top: 30px;


    .phone_num {
      margin-bottom: 14px;
    }


    .contact_icon {
      margin-right: 12px;
    }


    .follow {
      margin-top: 12px;
    }
  }


  .slogan {
    margin-top: 90px;
    flex: 1; // 新增：占据剩余空间，把 copyright 推到底部
    box-sizing: border-box;
    padding-left: 530px;
    color: #999;


    span {
      display: inline-block;
      width: 30px;
    }


    p:first-child {
      // font-size: 16px;
      font-size: 13px;
      margin-bottom: 5px;
      letter-spacing: 10px;


      // font-family: "SiYuanHeiTi_M";
    }


    p:last-child {
      // font-size: 12px;
      font-size: 10px;
      padding-top: 1px;
      letter-spacing: 4px;
    }
  }


  .copyright {
    width: 100%;
    height: 70px;
    display: flex;
    font-size: 12px;
    border-top: 1px solid #505050;
    flex-shrink: 0; // 新增：防止 copyright 被压缩


    div {
      display: flex;
      align-items: center;
    }
  }
}


// 工具类（如果你的项目没有这些，保留）
.df {
  display: flex;
}


.jcsb {
  justify-content: space-between;
}


.alic {
  align-items: center;
}


.fdc {
  flex-direction: column;
}


// 回到顶部的样式
.BackTop {
  position: fixed;
  right: 60px;
  bottom: 60px;
  width: 40px;
  height: 40px;
  background-color: #fff;
  color: #000;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1000;
}


.QrBtn {
  position: absolute;
  bottom: 42px;
  left: 2px;
}


.footerBtns {
  width: 1000px;
  height: 300px;
  // background: red;
  position: absolute;
  left: 512px;
  bottom: 78px;
}


// 导航栏
.footerBtns {
  display: flex;
  // justify-content: space-between;
  margin-top: 40px;
  padding: 30px 0;
}


.nav-column {
  // flex: 1;
  width: 200px;
  // margin-right: 40px;
}


.nav-column2 {
  width: 150px;
  // flex: 0.5 !important;
  // margin-right: 40px;
}


.nav-column3 {
  width: 390px;


  // flex: 0.5 !important;
  // margin-right: 40px;
  .double-col {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 180px;
    align-content: flex-start;
  }


  .double-col li {
    width: 30%;
    // height: 30.8px;
    // /* 固定高度确保对齐：14px * 2.2 */
    // box-sizing: border-box;
  }
}


.nav-column:last-child {
  margin-right: 0;
}


.nav-title {
  font-size: 17px;
  font-weight: 60;
  color: #fff;
  margin: 20px 0px 15px;
}


.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}


.nav-list li {
  font-size: 15px;
  color: #999;
  line-height: 2.2;
  cursor: pointer;
  transition: all 0.3s ease;
}


.nav-list li:hover {
  color: #fff;
}


/* 双列布局 */
.double-col {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 210px;
  align-content: flex-start;
  /* 从左开始排列，不强制平分 */
  /* 6个item的高度 ≈ 14px * 2.2 * 6 */
}


.double-col li {
  width: 36%;
  height: 30.8px;
  /* 固定高度确保对齐：14px * 2.2 */
  box-sizing: border-box;
}


// 主题内容部分
.routerView {
  padding-top: 100px;


}


.phone_num1 {
  font-size: 18px;
  font-weight: bold;
}


.publicNotice {
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    width: 50px;
  }

  .publicNoticePop {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s ease, visibility 0.2s ease;
    left: 60px;
    top: 0;
    white-space: nowrap;
    border-radius: 4px;

    /* 第一级：公司项 */
    .companyItem {
      position: relative;
      margin-top: 5px;

      .companyName {
        cursor: pointer;
        background: rgba(236, 236, 236, 0.85);
        padding: 4px 14px;
        border-radius: 4px;
        color: #000;
        font-size: 16px;
        margin: 0;
      }

      .companyName:hover {
        font-size: 20px;
        color: #084499;
        background: rgba(168, 202, 248, 0.85);
      }

      /* 第二级：报告列表 */
      .reportList {
        position: absolute;
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.2s ease, visibility 0.2s ease;
        left: 100%;
        top: 0;
        padding-left: 5px;
        white-space: nowrap;
        border-radius: 4px;
        max-height: 320px;
        overflow-y: auto;
        overflow-x: hidden;

        /* 自定义滚动条 适配webkit浏览器（Chrome、Edge、360等） */
        &::-webkit-scrollbar {
          width: 0px;
        }

        &::-webkit-scrollbar-track {
          background: #f5f5f5;
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
          background: #e2e8f0;
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb:hover {
          background: #cbd5e1;
        }

        p {
          cursor: pointer;
          background: rgba(236, 236, 236, 0.85);
          padding: 4px 8px;
          border-radius: 4px;
          margin-top: 5px;
          color: #000;
          font-size: 16px;
        }

        p:hover {
          font-size: 20px;
          color: #084499;
          background: rgba(168, 202, 248, 0.85);
        }
      }
    }

    .companyItem:hover .reportList {
      opacity: 1;
      visibility: visible;
    }
  }
}

.publicNotice:hover .publicNoticePop {
  opacity: 1;
  visibility: visible;
}
</style>
